import type { ProductFamily } from 'product/types/Product'

export function getMainFamily({
	families,
}: {
	families: ProductFamily[]
}): ProductFamily {
	return (
		families.find((family) => family.isMainFamily) ||
		families[0] || { labelEn: 'nofamily', hasSizeGuide: true }
	)
}
